<template>
  <div class="inbox" ref="inboxRef" style="padding: 6px;">
    <el-table
        :data="tableData"
        style="width: 100%;height:max-content;max-height: 55vh;overflow: scroll"
        ref="TableRef"
        v-loading="loading"
        class="talberscrolls"
        :cell-style="rowClassName"
        :header-cell-style="headerClassName"
        @cell-mouse-leave="clearVisiblePopover"
    >
      <el-table-column width="120">
      </el-table-column>
      <el-table-column :label="$t('common_customer_type')" prop="customerType">
        <template #default="{ row, column, $index }">
          <template v-if="!row.editing">
            <div :ref="ref => (refMap[`${row.id}_type_customer`] = ref)"
                 @mouseover.stop="handleRef(refMap[`${row.id}_type_customer`], row, 1)"
                 v-if="getTextWidth(row.customerType) > 200"
                 class="over_normal"
                 :key="row.customerType">
              {{
                getTextLength(row.customerType) > sizeMaxNumber ? formatText(row.customerType, sizeMaxNumber) : row.customerType
              }}
            </div>
            <div v-else>
              {{ row.customerType }}
            </div>
          </template>
          <div v-else>
            <el-input style="width: 200px" size="small" v-model.number="row.customerType" @change="handleClickInput"
                      @keydown.native.enter="handleBlur(row, column, $index)"
                      :class="[isError||unAddPre?'isErrorSelect':'normal']"></el-input>
            <span v-if="isError||unAddPre"
                  style="margin-left:4px;color: var(--el-color-danger);font-size: 12px;">
              {{ $t('common.customer.type.empty') }}
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="120">
      </el-table-column>
      <el-table-column :label="$t('common_customer_level')" prop="customerLevel">
        <template #default="{ row, column, $index }">
          <div v-if="!row.editing">
            {{ row.customerLevel }}
          </div>
          <div v-else>
            <el-select style="width: 200px" size="small" v-model="row.customerLevel"
                       :placeholder="$t('common.please.select')" clearable
                       :class="[isErrorSelect||unAddPre?'isErrorSelect':'normal']" @change="handleChange">
              <el-option
                  v-for="item in trueCustomerLevels"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              ></el-option>
            </el-select>
            <span v-if="isErrorSelect||unAddPre"
                  style="margin-left:4px;color: var(--el-color-danger);font-size: 12px;text-align: left;position: absolute">
              {{ $t('common.customer.level.empty') }}
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="120">
      </el-table-column>
      <el-table-column :label="$t('common.operate')">
        <template #default="{ row, column, $index }">
          <div v-if="!row.editing">
            <div class="settings">
              <el-button
                  type="primary"
                  link
                  size="small"
                  @click="handleEdit(row, column, $index)"
              >{{ $t('common.edit') }}
              </el-button
              >
              <el-popover
                  :visible="row.popoverVisible"
                  placement="top"
                  :width="164"
                  trigger="click"
                  :show-after='1200'
              >
                <div class="inners">
                  <!--                  <el-icon>-->
                  <!--                    <WarningFilled/>-->
                  <!--                  </el-icon>-->
                  <p>{{ $t('sys.message.ask.type.delete') }}</p>
                </div>
                <div style="text-align: center; margin-top:10px">
                  <el-button
                      size="small"
                      @click="cancelPopover(row, column, $index)"
                  >{{ $t('common.cancel') }}
                  </el-button
                  >
                  <el-button
                      size="small"
                      type="primary"
                      @click="handleDelete(row, column, $index)"
                  >{{ $t('common.confirm') }}
                  </el-button>
                </div>
                <template #reference>
                  <el-button
                      type="danger"
                      link
                      size="small"
                      @click="requestHandleDelete(row, column, $index)"
                  >{{ $t('common.delete') }}
                  </el-button
                  >
                </template>
              </el-popover>
              <el-button
                  type="primary"
                  link
                  size="small"
                  @click="handleTop(row, column, $index)"
              >{{ $t('common.cds40') }}
              </el-button>
            </div>
          </div>
          <div v-else>
            <div class="settings">
              <el-button
                  type="primary"
                  link
                  size="small"
                  @click="handleBlur(row, column, $index)"
              >{{ $t('common.save') }}
              </el-button
              >
              <el-button
                  type="danger"
                  link
                  size="small"
                  @click="handleCancel(row, column, $index)"
              >{{ $t('common.sss16') }}
              </el-button
              >
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="120">
      </el-table-column>
      <template #empty>
        <el-empty :description="$t('common.data.empty')" :image="emptyUrl"/>
      </template>
    </el-table>
    <div class="footer">
      <el-button
          :icon="Plus"
          type="primary"
          size="small"
          @click="addNewTableItem()"
      >{{ $t("common.customer.level.add") }}
      </el-button
      >
    </div>
    <!--    </el-scrollbar>-->
  </div>
  <!--  el-popover-->
  <el-popover
      v-model:visible="visiblePopover"
      :virtual-ref="tempRef"
      virtual-triggering
      :width="'max-content'"
      trigger="hover"
      :show-after="1200"
      effect="dark"
  >
    <template v-if="popoverType === 1">
      <div class="popover-content">{{ activeItemElpopover.customerType }}</div>
    </template>
  </el-popover>
</template>

<script setup>
import {ref, onMounted, computed, onUpdated, onBeforeUpdate, watch, nextTick, onUnmounted} from "vue";
import {Plus} from "@element-plus/icons-vue";
import dayjs from "dayjs";
import {ElMessage, ElTable} from "element-plus";
import {useStore} from "vuex";
import {
  addMailCustomerFollowLevel,
  getMailCustomerLevelList,
  deleteMailCustomerLevel,
  editMailCustomerLevel,
} from "@/api/customer.js";
import {i18n} from "@/lang";
import {emptyUrl, POPOVER_DELAY_TIME} from "@/utils/statusParams";
import {useRouter} from "vue-router";
import {debouncePlus, throttle} from "@/utils/mylodash";
import {formatText, getTextLength, getTextWidth} from "@/utils/util";

const router = useRouter()
const store = useStore();
const tableData = computed(() => store.state.cusList.tableData);
const loading = ref(false)
const customerLevels = [
  {value: "A", label: "A"},
  {value: "B", label: "B"},
  {value: "C", label: "C"},
  {value: "D", label: "D"},
  {value: "E", label: "E"},
  {value: "F", label: "F"},
  {value: "G", label: "G"},
  {value: "H", label: "H"},
  {value: "I", label: "I"},
  {value: "J", label: "J"},
  {value: "K", label: "K"},
  {value: "L", label: "L"},
  {value: "M", label: "M"},
  {value: "N", label: "N"},
  {value: "O", label: "O"},
  {value: "P", label: "P"},
  {value: "Q", label: "Q"},
  {value: "R", label: "R"},
  {value: "S", label: "S"},
  {value: "T", label: "T"},
  {value: "U", label: "U"},
  {value: "V", label: "V"},
  {value: "W", label: "W"},
  {value: "X", label: "X"},
  {value: "Y", label: "Y"},
  {value: "Z", label: "Z"},
  // Add more options as needed
];

const customerLevelsAddArray = [
  {value: "A1", label: "A1"},
  {value: "B1", label: "B1"},
  {value: "C1", label: "C1"},
  {value: "D1", label: "D1"},
  {value: "E1", label: "E1"},
  {value: "F1", label: "F1"},
  {value: "G1", label: "G1"},
  {value: "H1", label: "H1"},
  {value: "I1", label: "I1"},
  {value: "J1", label: "J1"},
  {value: "K1", label: "K1"},
  {value: "L1", label: "L1"},
  {value: "M1", label: "M1"},
  {value: "N1", label: "N1"},
  {value: "O1", label: "O1"},
  {value: "P1", label: "P1"},
  {value: "Q1", label: "Q1"},
  {value: "R1", label: "R1"},
  {value: "S1", label: "S1"},
  {value: "T1", label: "T1"},
  {value: "U1", label: "U1"},
  {value: "V1", label: "V1"},
  {value: "W1", label: "W1"},
  {value: "X1", label: "X1"},
  {value: "Y1", label: "Y1"},
  {value: "Z1", label: "Z1"},
  // Add more options as needed
];


// el-popover 优化
const refMap = ref({})
const tempRef = ref()
const visiblePopover = ref(false)
// -1-字句审核 0-整句审核 1-日志查看
const popoverType = ref(0)
const activeItemElpopover = ref(null)

const handleRef = debouncePlus((ref, item, type) => {
  console.log('refMap', refMap.value)
  tempRef.value = ref
  popoverType.value = type
  activeItemElpopover.value = item;
  if (type === 1) {
    // ...业务逻辑1
  } else {
    // ...业务逻辑2、3
  }
  visiblePopover.value = true
}, POPOVER_DELAY_TIME)

const inboxRef = ref(null);

const trueCustomerLevels = computed(() => {
  const targetObj = tableData.value.map(item => item.customerLevel)
  let result = customerLevels.filter(item => !targetObj.includes(item.value))
  if (result.length === 1) {
    result = [...result, ...customerLevelsAddArray]
  }
  return result;
})

// 记录状态是否编辑
let isEdit = false;

const teamId = computed(() => store.state.email.teamID)
// 编辑用户
const handleEdit = async (row, column, index) => {
  if (!isEditing.value) {
    isEditing.value = true
    store.commit("cusList/changeEditing", {index, flag: true});
    isEdit = false;
  } else {
    ElMessage.warning("您当前正处于编辑中，请保存后再进行编辑！")
  }
};

const isAdd = ref(false);
// 是否新增了第一个新增项
const unAddPre = ref(false)
// 添加
const addNewTableItem = () => {
  if (!isEditing.value) {
    if (isAdd.value) {
      unAddPre.value = true
      return
    }
    isAdd.value = true;
    isEdit = true;
    tableData.value.push({
      "customerType": "",
      "alertDay": 0,
      "customerLevel": "",
      "editing": true
    });
    nextTick(() => {
      scrollBehavior()
    })
  } else {
    ElMessage.warning("您当前正处于编辑中，请保存后再进行添加！")
  }
};

// table的虚拟dom
const TableRef = ref()

// 滚动行为
function scrollBehavior(e) {
  // // 获取提供实际滚动的容器
  nextTick(() => {
    const bodyWrapper = document.getElementsByClassName('talberscrolls')[0]
    if (bodyWrapper) {
      bodyWrapper.scrollTop = bodyWrapper.scrollHeight
    }
  })
}

const isEditing = ref(false)
const isError = ref(false)
const isErrorSelect = ref(false)

const handleClickInput = (value) => {
  if (value) {
    isError.value = false
  } else {
    isError.value = true
  }
}

const handleChange = (value) => {
  if (value) {
    isErrorSelect.value = false
  } else {
    isErrorSelect.value = true
  }
}

//保存
const handleBlur = async (row, column, index) => {
  isEditing.value = false
  const {customerLevel, customerType, id} = row;
  const targetParams = {
    alertDay: !isEdit ? -1 : 0,
    createBy: "",
    createTime: dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    customerLevel,
    customerType,
    delFlag: 0,
    id,
    remark: "",
    teamId: teamId.value,
    updateBy: "",
    updateTime: dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss"),
  };
  console.log(customerType, customerLevel, 'dddddddddd')
  if (!`${customerType}` || customerType === undefined) {
    isError.value = true
  }
  if (!`${customerLevel}` || customerLevel === undefined) {
    isErrorSelect.value = true
  }
  if (isError.value || isErrorSelect.value) {
    return
  }
  isError.value = false
  isErrorSelect.value = false
  if (isEdit) {
    await store.dispatch("cusList/addCustomerData", targetParams);
    //console.log('fff@@@')
    isEdit = false;
  } else {
    await store.dispatch("cusList/editCustomerData", targetParams);
    isEdit = true;
  }
  isAdd.value = false;
  unAddPre.value = false
  store.commit("cusList/changeEditing", {index, flag: false});
  await store.dispatch("cusList/getMailCustomerLevel", {isUpdate: true, teamId: teamId.value});
};

const handleTop = async (row, column, index) => {
  const {customerLevel, customerType, id} = row;
  const targetParams = {
    alertDay: !isEdit ? -1 : 0,
    createTime: dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    customerLevel,
    customerType,
    delFlag: 0,
    id,
    teamId: teamId.value,
    updateTime: dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    isTop: 1,
  };
  await store.dispatch("cusList/editCustomerData", targetParams);
  await store.dispatch("cusList/getMailCustomerLevel", {isUpdate: true, teamId: teamId.value});
}


// 取消
const handleCancel = async (row, column, index) => {
  isAdd.value = false;
  unAddPre.value = false;
  isError.value = false;
  isErrorSelect.value = false;
  isEditing.value = false;
  store.commit("cusList/changeEditing", {index, flag: false});
  await store.dispatch("cusList/getMailCustomerLevel", {isUpdate: true, teamId: teamId.value});
};

// 删除
const handleDelete = async (row, column, index) => {
  const {id} = row;
  let res = await deleteMailCustomerLevel({id: id});
  if (res.code !== 200) {
    ElMessage.error(res.message);
    return;
  }
  ElMessage.success(res.result);
  row.popoverVisible = false;
  await store.dispatch("cusList/getMailCustomerLevel", {isUpdate: true, teamId: teamId.value});
};

const requestHandleDelete = (row) => {
  row.popoverVisible = true;
};

const cancelPopover = async (row) => {
  row.popoverVisible = false;
  await store.dispatch("cusList/getMailCustomerLevel", {teamId: teamId.value});
};

onMounted(async () => {
  loading.value = true;
  try {
    await store.dispatch("cusList/getMailCustomerLevel", {teamId: teamId.value});
  } catch (error) {
    console.error("Failed to fetch customer levels:", error);
  } finally {
    loading.value = false;
  }
})


const rowClassName = ({row, column, rowIndex, columnIndex}) => {
  // console.log(row, columnIndex)
  if (columnIndex === 10) {
    return {textAlign: 'left'}
  } else {
    return {textAlign: 'center'}
  }
}

const headerClassName = ({row, column, rowIndex, columnIndex}) => {
  if (columnIndex === 10) {
    return {'text-align': 'left', background: '#f9f9f9', color: 'black', padding: '8px 0px'}
  } else {
    return {'text-align': 'center', background: '#f9f9f9', color: 'black', padding: '8px 0px'}
  }
}

const sizeMaxNumber = ref(13)
const clearVisiblePopover = () => {
  setTimeout(() => {
    visiblePopover.value = false
  }, POPOVER_DELAY_TIME + 5)
}
</script>
<style scoped lang="less">
.settings {
  display: flex;
  justify-content: center;
}

.inners {
  display: flex;
  justify-content: center;
  align-items: center;

  & > .el-icon {
    color: #faad14;
    margin-right: 2px;
  }
}

:deep(.el-table tr) {
  background: white !important;
}

.footer {
  height: 65px;
  background: #fafafa;
  border-top: 1px solid #e8e8e8;
  border-radius: 0 0 4px 4px;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  & > .el-button {
    margin-left: 20px;
  }
}

:deep(.el-empty__image img) {
  width: 54% !important;
}

.inbox {
  background-color: #fff;
  height: 100%;
}

.isErrorSelect {
  border: 1px solid red;
  border-radius: 4px;
  transition: border .2s;
}

.normal {
  border: 1px solid transparent;
  border-radius: 4px;
  transition: border .2s;
}

.popover-content {
  max-width: 300px;
  max-height: 200px;
  overflow-y: auto;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;
}
</style>
